import React from 'react';
import PropTypes from 'prop-types';
import ActivismBlockInfo from '../../../02_molecules/ActivismBlockInfo';
import ActivismResource from './ActivismResource';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBActivismResources = ({
  title = '',
  subtitle = '',
  items = [],
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb ${styles['bb-activism-resources']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <ActivismBlockInfo title={title} subtitle={subtitle} size="large" />

    <div className="container">
      <div className={styles['bb-activism-resources__items-list']}>
        {items.map((item, index) => (
          <ActivismResource number={index + 1} key={`bb-activism-resource-${index}`} {...item} />
        ))}
      </div>
    </div>
  </div>
);

BBActivismResources.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBActivismResources;
